import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {Announcement} from '../../models/announcements-model';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  constructor(private readonly http: HttpClient) {
  }

  fetchActiveAnnouncements(): Observable<Announcement[]> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get<Announcement[]>('api/announcement', { headers });
  }
}
